import { generateClassName } from '@klv/shared/utils/functions';
import NewsFeed from '../news-feed';

import * as styles from './styles/twoColumnWithNewsfeed.module.scss';

import type { ITwoColumnWithNewsfeed } from './types';

const TwoColumnWithNewsfeed = ({
  backgroundColor = 'light',
  children,
  className,
  newsfeed,
  ...props
}: ITwoColumnWithNewsfeed) => (
  <div
    className={generateClassName(['twoColumnWithNewsfeed', className, styles.twoColumnWithNewsfeed])}
    {...props}
  >
    <div className={generateClassName(['grid', styles.grid])}>
      <div className={styles.childSlot}>
        {children}
      </div>
      <NewsFeed
        backgroundColor={backgroundColor}
        {...newsfeed}
      />
    </div>
  </div>
);

export default TwoColumnWithNewsfeed;
